import React from 'react'
import {
  ListFilter, FloatingFilter,
} from '../../../components'
import {
  ListNav,
  List
} from './index'
import dummyData from '../../../database/events.json'
import { Featured } from './featured'

const MainContentMobile = ({embed}) => {
  const [filtered, setFiltered] = React.useState(false)
  const [data, setData] = React.useState(dummyData)

  React.useEffect(() => {
    if(filtered){
      setData(dummyData.slice(0, 3))
    }else{
      setData(dummyData)
    }
  }, [filtered])

  return (
    <div>
      <div className="md:hidden">
        {
          embed &&
          <div className="container mx-auto">
            <ListNav embed={embed}/>
          </div>
        }
        {
          !embed &&
          <ListNav />
        }
        {
          !filtered &&
          <Featured embed={embed}/>
        }
        <ListFilter filtered={filtered} setFiltered={setFiltered}/>
      </div>
      <div className="hidden md:block">
        <div className="container mx-auto">
          <ListNav embed={embed}/>
          <ListFilter filtered={filtered} setFiltered={setFiltered}/>
        </div>
        {
          !filtered &&
          <Featured embed={embed}/>
        }
      </div>
      <section className="container mx-auto">
        <List data={data} embed={embed}/>
      </section>
      <FloatingFilter onSubmit={() => setFiltered(true)}/>
    </div>
  )
}

export { MainContentMobile }
